import Formulario from "./pages/Formulario";
import sbadmin from "./css/sb-admin-2.min.css";

import { HashRouter as Router, Route, Routes } from "react-router-dom";
import Salida from "./pages/salida";
import Confirmacion from "./pages/Confirmacion";
import Excusas from "./pages/Excusas";
function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Formulario />} />
        </Routes>
        <Routes>
          <Route path="/salida" element={<Salida />} />
        </Routes>
        <Routes>
          <Route path="/confirma" element={<Confirmacion />} />
        </Routes>
        <Routes>
          <Route path="/excusas" element={<Excusas />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
